import React, { FC } from 'react';
import { Box, BoxExtendedProps } from 'grommet';

const BoxComponent: FC<BoxExtendedProps> = ({ children, ...props }) => {
  return <Box {...props}>{children}</Box>;
};

export default BoxComponent;
